import * as Muicon from '@mui/icons-material';

export function DynamicIcon({ iconName, className }: { iconName: string; className?: string }) {
  const isValidIcon = Muicon[iconName as keyof typeof Muicon] !== undefined;
  const Icon = Muicon[iconName as keyof typeof Muicon];

  return isValidIcon ? <Icon className={className} /> : <></>;
}
